<template>
  <div class="popup" style="background: #fff">

    <chatDetail v-if="showChatDetail" :row="row" @showChatDetailEvent="showChatDetailEvent"></chatDetail>

    <div v-else>
        <div style="display: flex; justify-content: space-around; font-weight: 800">
        <div
          style=" width: 200px; background-color: rgb(251 201 30); height: 100px; border-radius: 10px;">

          <div style="display: flex; padding-top: 30px; padding-left: 16px"> 叮嘱总量:{{ dataTop.teacherOk }} </div>

          <div style="margin-left: 219px; margin-top: -42px">
            <div
              style="
                width: 200px;
                background-color: rgb(233 149 150);
                height: 30px;
                border-radius: 10px;
                padding: 5px 0px;
                margin-bottom: 10px;
                text-align: start;
                line-height: 26px;
                padding-left: 10px;
              ">
              已完成叮嘱:{{ dataTop.teacherDaiTiJiao }}
            </div>
            <div
              style="
                width: 200px;
                background-color: rgb(94 190 243);
                height: 30px;
                border-radius: 10px;
                padding: 5px 0px;
                margin-bottom: 10px;
                text-align: start;
                line-height: 26px;
                padding-left: 10px;
              "
            >
              待完成叮嘱:{{ dataTop.xueguanshenhezhong }}
            </div>
          </div>
        </div>

        <div
          style="
            width: 200px;
            height: 100px;
            border-radius: 10px;
            padding-top: 8px;">
          <div style=" width: 200px;
                background-color: rgb(94 190 243);
                height: 30px;
                border-radius: 10px;
                padding: 5px 0px;
                margin-bottom: 10px;
                text-align: start;
                line-height: 26px;
                padding-left: 10px;background-color: rgb(213 87 223);">
            销售待完成:{{ dataTop.marketNotOk }}
          </div>
          <div style=" width: 200px;
                background-color: rgb(94 190 243);
                height: 30px;
                border-radius: 10px;
                padding: 5px 0px;
                margin-bottom: 10px;
                text-align: start;
                line-height: 26px;
                padding-left: 10px;background-color: rgb(125 219 218);">
            销售已完成:{{ dataTop.marketOk }}
          </div>
        </div>
      </div>

      <p class="popup_top" style="text-align: left; margin-top: 15px"> </p>

      <el-form class="demo-form-inline" label-width="150px">


        <!-- <el-form-item label="学生姓名:">
          <el-select
            placeholder="请选择学生"
            v-model="formDate.student"
            style="width: 100%"
            clearable
            filterable>
            
            <el-option
              v-for="item in studentArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item> -->


        <el-form-item label="线下学员:">
          <el-select
            placeholder="请选择学生"
            v-model="formDate.student"
            style="width: 100%"
            clearable
            filterable>
            
            <el-option
              v-for="item in studentArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>

        


        <el-form-item label="教师姓名:">
          <el-select
            placeholder="请选择师"
            v-model="formDate.teacher"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in teacherArr"
              :key="item.id"
              :value="item.id"
              :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="跟进助理:">
          <el-select
            placeholder="请选择师"
            v-model="formDate.assistantId"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in teacherArrr"
              :key="item.id"
              :value="item.id"
              :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item>


        <el-form-item label="规划学员:">
          <el-select
            placeholder="请选择学生"
            v-model="formDate.student1"
            style="width: 100%"
            clearable
            filterable>
            
            <el-option
              v-for="item in studentArr1"
              :key="item.id"
              :value="item.id"
              :label="item.realname">
            </el-option>
          </el-select>
        </el-form-item> 

        <el-form-item label="科目:">
          <el-select
            placeholder="请选择科目"
            v-model="formDate.subject"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in subjectArr"
              :key="item.id"
              :value="item.id"
              :label="item.categoryName">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="教师完成情况:">
          <el-select
            placeholder="请选择教师完成情况"
            v-model="formDate.teacherCompleted"
            style="width: 100%"
            clearable
            filterable >
            <el-option
              v-for="item in teacherCompletedArr"
              :key="item.value"
              :value="item.value"
              :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="销售完成情况:">
          <el-select
            placeholder="请选择销售完成情况"
            v-model="formDate.salesCompleted"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in salesCompletedArr"
              :key="item.value"
              :value="item.value"
              :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="销售最新审阅情况:">
          <el-select
            placeholder="请选择销售最新审阅情况"
            v-model="formDate.salesReview"
            style="width: 100%"
            clearable
            filterable>
            <el-option
              v-for="item in salesReviewArr"
              :key="item.value"
              :value="item.value"
              :label="item.label">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="最近沟通时间">
          <el-date-picker
            v-model="formDate.recentlyTime"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="销售完成时间">
          <el-date-picker
            v-model="formDate.salesTime"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>

        <el-form-item label="消息创建时间">
          <el-date-picker
            v-model="formDate.createTime"
            clearable
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>


        <el-form-item label="所在地域:" >
            <el-select v-model="formDate.regionName" clearable filterable placeholder="请选择所在地域"  style="width: 100%;">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
      </el-form-item>

      </el-form>

      <p style="width: 98%; text-align: right">
        <el-button type="primary" @click="searchBtn" size="small" class="btns" icon="el-icon-search" >搜索</el-button>
        <el-button type="primary"  @click="clearBtn" class="btns" size="small" icon="el-icon-close">清空</el-button >
        <el-button type="primary"  @click="addBtn" class="btns" size="small" icon="el-icon-plus">新建叮嘱</el-button >
        <el-button type="primary"  @click="downloadBtn" class="btns" size="small" icon="el-icon-download">导出</el-button >
        <el-button type="primary"  @click="downloadBtn_s" class="btns" size="small" icon="el-icon-download">叮嘱消息详情导出</el-button>
      </p>

      <el-table :data="tableData"  height="500" stripe style="width: 99%; margin: 20px auto"  border
        :header-cell-style="{ background: '#fafafa','text-align': 'center', }" :cell-style="{ 'text-align': 'center' }"
        loading-text="数据加载中" v-loading="isLoading" >

        <el-table-column prop="teacher.realname" label="教师姓名"> </el-table-column>
        <el-table-column prop="msg.regionName" label="所在地域" width="100"></el-table-column>

        <el-table-column prop="teacher.assistantName" label="跟进助理"> </el-table-column>

        <el-table-column prop="student.realname" label="学生姓名"> </el-table-column>

        <el-table-column prop="subject.categoryName" label="学科"> </el-table-column>

        <el-table-column label="详情">
          <template slot-scope="scope">
            <el-button type="text" @click="detail(scope.row)">详情</el-button>
          </template>
        </el-table-column>

        <el-table-column prop="msg.theLatestTime" label="最新沟通时间" width="200"></el-table-column>
        <el-table-column prop="msg.createTime" label="消息创建时间" width="200"></el-table-column>
        <el-table-column prop="msg.salesTime" label="销售完成时间" width="200"></el-table-column>

        <el-table-column prop="msgContext" label="销售最新审阅情况" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.msgContext[scope.row.msgContext.length - 1].marketCheckStatus == 3">已审阅</span>
            <span v-if="scope.row.msgContext[scope.row.msgContext.length - 1].marketCheckStatus == 2">未审阅</span>
            <span v-if="scope.row.msgContext[scope.row.msgContext.length - 1].marketCheckStatus == 1">初始待提交</span>
          </template>
        </el-table-column>

        <el-table-column prop="msg.msgStatus" label="教师完成情况" width="200">
          <template slot-scope="scope">
            <span v-if="scope.row.msg.msgStatus == 2">已完成</span>
            <span v-if="scope.row.msg.msgStatus == 1">进行中</span>
            <span v-if="scope.row.msg.msgStatus == 3">已取消</span>
          </template>
        </el-table-column>

        <el-table-column prop="msg.remark" label="上传截图">
          <template slot-scope="scope">
              <img  v-if="scope.row.msg.remark"
              :src="scope.row.msg.remark"
              :alt="scope.row.msg.remark"
              @click="handleImgClick(scope.row.msg.remark)"
              style="width: 100%; height: 100%;">
          </template>
        </el-table-column>

        <el-table-column prop="msg.marketStatus" label="销售完成情况" width="250px">
          <template slot-scope="scope">
            <el-radio-group  :disabled="scope.row.msg.marketStatus == 1" v-model="scope.row.msg.marketStatus" @change="changeMarke(scope.row)">
              <el-radio :label="1">已完成</el-radio>
              <el-radio :label="2">未完成</el-radio>
            </el-radio-group>
          </template>
        </el-table-column>

      </el-table>

      <el-pagination
        style="margin-bottom: 100px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.pageNo"
        :page-size="pagination.pageSize"
        layout="total, prev, pager, next"
        :total="pagination.total">
      </el-pagination>




      <el-dialog title="新建叮嘱" :visible.sync="isNewReminder" width="50%" :before-close="handleNewReminderClose">


        <el-row>
          <el-col :span="4"> <div style="line-height: 38px;margin-bottom: 50px;">教师姓名：</div> </el-col>
          <el-col :span="20">
            <el-select
              placeholder="请选择教师"
              v-model="ewReminder.teacher"
              @change="handleTeacherChange"
              style="width: 100%"
              clearable
              filterable>
              <el-option
                v-for="item in teacherArr"
                :key="item.id"
                :value="item.id"
                :label="item.realname">
              </el-option>
            </el-select>
          </el-col>
        </el-row>


        <el-row>
          <el-col :span="4"> <div style="line-height: 38px;margin-bottom: 50px;">学生学员：</div> </el-col>
          <el-col :span="20">
            <el-select
              placeholder="请选择学生"
              v-model="ewReminder.student"
              @change="handleStudentChange"
              style="width: 100%"
              clearable
              filterable>
              <el-option
                v-for="item in studentArr_s"
                :key="item.id"
                :value="item.id"
                :label="item.realname">
              </el-option>
            </el-select>
          </el-col>
        </el-row>




        <el-row>
          <el-col :span="4"> <div style="line-height: 38px;margin-bottom: 50px;">科目：</div> </el-col>
          <el-col :span="20">
            <el-select
              placeholder="请选择科目"
              v-model="ewReminder.subject"
              style="width: 100%"
              clearable
              filterable>
              <el-option
                v-for="item in subjectArr_s"
                :key="item.categoryId"
                :value="item.categoryId"
                :label="item.categoryName">
              </el-option>
            </el-select>
          </el-col>
        </el-row>

        <div style="margin-top: 50px;">
          <el-button type="primary"  @click="dialogCler" size="small" class="btns" icon="el-icon-close">取消</el-button>
          <el-button type="primary"  @click="dialogSubit" class="btns" size="small" icon="el-icon-search" style="margin-left: 30px;">提交</el-button >
        </div>

      </el-dialog>


      <el-dialog title="请上传完成截图" :visible="screenshotShow" width="50%" @before-close="handlescreenshotCler">
              <el-upload
              class="avatar-uploader"
              ref="upload"
              action="#"
              :on-remove="handleRemove"
              :beforeUpload="beforeUpload"
              :file-list="fileLists"
              :http-request="handleUpload"
              :auto-upload="true"
              drag
              :limit="1"
              accept=".png,.jpg,.pdf">
              <img v-if="screenshot" :src="screenshot" style="width: 100%;height: 100%;" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>

            <div  class="dialog-footer" style="margin-top: 100px;">
              <el-button @click="handlescreenshotCler" style="margin-right: 50px;">取 消</el-button>
              <el-button type="primary" @click="handlescreenshotSubmit">确 定</el-button>
            </div>
      </el-dialog>


      <el-dialog :visible.sync="isShowImg" width="50%">
        <el-image v-if="isShowImg" :src="showImg"></el-image>
      </el-dialog>
    </div>


  </div>
</template>

<script>
import { getTeachers, getStudents,  getSubject, getStudentsType } from "@/api/fiveClassApi"
import {  getList, ApiExhortNews, ApiStatus, ApigetStudentMsgList, ApigetSubjectMsgList } from "@/api/weekendReminder"
import { put, signatureUrl, getFileNameUUID } from "../../utils/oss";
import loadingUtils from "../../utils/loading";
import axios from "axios";
import apiBaseUrl from "../../../config/api";


import { ref, reactive, onMounted } from '@vue/composition-api'
import React from 'react';
import ReactDOM from 'react-dom';

// import { useState } from 'vue-hooks-plus';


// import MyReactComponent from '../reactComponents/MyReactComponent'

import chatDetail from './chatDetail'

export default {

  setup(props, { root, refs }) {
    onMounted(()=>{

    })
  },

  components:{ chatDetail },
  data(){
    return{
      dataTop: {
        xueguanshenhezhong:0,
        teacherOk:0,
        teacherDaiTiJiao:0,
        marketOk:0,
        marketNotOk:0,
      },

      formDate: {
        student:"",
        student1:"",
        teacher:"",
        subject:"",
        teacherCompleted:"",
        salesCompleted:"",
        salesReview:"",
        recentlyTime:[],
        createTime:[],
        salesTime:[],
        assistantId:'',
        regionName:'' 
      },

      ewReminder:{
        teacher:"",
        student:"",
        subject:"",
      },

      pagination:{
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },

      tableData: [],

      studentArr:[],
      studentArr1:[],

      teacherArr:[],
      teacherArrr:[],
      subjectArr:[],
      teacherCompletedArr:[{ value: 1, label: "进行中" },{ value: 2, label: "已完成" }],
      salesCompletedArr:[{ value: 2, label: "未完成" },{ value: 1, label: "已完成" }],
      salesReviewArr:[{ value: 3, label: "已审阅" },{ value: 2, label: "未审阅" },{ value: 1, label: "初始待提交" }],


      isNewReminder:false,
      screenshotShow:false,
      screenshot:"",
      fileLists:[],


      isShowImg:false,
      showImg:"",

      isLoading:true,

      showMsg:null,


      studentArr_s:[],
      subjectArr_s:[],

      showChatDetail:false,
      row:null,

      optionsListt:[
        {dictValue:"北京", dictType:1 },
        {dictValue:"深圳", dictType:2 },
      ],

    }
  },



  mounted(){
    this.handleInitialization()
    this.getListData()
      
    // this.handleApiGetMessageState()

    axios.get(`${ apiBaseUrl }/dict//getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data})
  },

  methods:{
    downloadBtn_s(){
      if(this.formDate.createTime.length > 0){
        let data = {
          createStartTime: this.formDate.createTime[0],
          createEndTime: this.formDate.createTime[1],
          msgType: 1,
        }
        axios.post(`${apiBaseUrl}/msg/excelTeacherStudentMsg`, data, { responseType: "blob" }).then((res) => {
            const blob = new Blob([res.data], { type: "application/vnd.ms-excel",});
            const downloadLink = document.createElement("a");
            downloadLink.href = URL.createObjectURL(blob);
            downloadLink.download = "叮嘱消息详情.xlsx"; 
            downloadLink.click();
        })
      }else{
        this.$message({type: 'warning',message: '消息创建时间不能为空'});
      }
    },

    downloadBtn(){

      let str = ""
      if(this.formDate.student){
        str = this.formDate.student + ''
        if(this.formDate.student1){
          str =  this.formDate.student + ',' + this.formDate.student1
        }
      }else{
        if(this.formDate.student1){
          str = this.formDate.student1  + ''
        }
      }


      const data = {
         phone: "",
         msgType: 1,
         pageIndex: this.pagination.pageNo,
         pageSize: this.pagination.pageSize,

         studentIds: str,

        // studentId:this.formDate.student,

         teacherId: this.formDate.teacher,
         subject: this.formDate.subject,
         msgStatus: this.formDate.teacherCompleted,
         marketStatus: this.formDate.salesCompleted,
         marketCheckStatus: this.formDate.salesReview,
         startTime: this.formDate.recentlyTime ? this.formDate.recentlyTime[0] : "",
         endTime: this.formDate.recentlyTime ? this.formDate.recentlyTime[1] : "",
         salesStartTime: this.formDate.salesTime ? this.formDate.salesTime[0] : "",
         salesEndTime: this.formDate.salesTime  ? this.formDate.salesTime[1] : "",
         createStartTime: this.formDate.createTime ? this.formDate.createTime[0] : "",
         createEndTime: this.formDate.createTime ? this.formDate.createTime[1] : "",
      };
      axios.post(`${apiBaseUrl}/msg/excelMessage`, data, { responseType: "blob",
   
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        
    }).then((res) => {
          const blob = new Blob([res.data], { type: "application/vnd.ms-excel",});
          const downloadLink = document.createElement("a");
          downloadLink.href = URL.createObjectURL(blob);
          downloadLink.download = "叮嘱信息.xlsx"; 
          downloadLink.click();
      });
    },


    handleTeacherChange(){
      this.handleApigetStudentMsgList()
    },
    handleStudentChange(){
      this.handleApigetSubjectMsgList()
    },
    handleStudentChange1(){
      this.handleApigetSubjectMsgList()
    },
    handleApigetStudentMsgList(){
      let data = { teacherId: this.ewReminder.teacher }
      ApigetStudentMsgList(data).then((res)=>{
        if(res){
          this.studentArr_s = res
        }
      })
    },
    handleApigetSubjectMsgList(){
      let data = { teacherId: this.ewReminder.teacher, studentId: this.ewReminder.student }
      ApigetSubjectMsgList(data).then((res)=>{
        if(res.data){
           this.subjectArr_s = res.data
        }
      })
    },
    // handleApiGetMessageState(){
    //   ApiGetMessageState().then((res)=>{
    //     if(res.code == 200){

    //       let dataTop = {
    //         xueguanshenhezhong: res.data.unfinishedWharn,
    //         teacherOk: res.data.messageTotal,
    //         teacherDaiTiJiao: res.data.accomplisWharn,
    //         marketOk: res.data.marketAccomplish,
    //         marketNotOk: res.data.marketUnfinished,
    //       }
    //       this.dataTop = dataTop
    //     }
    //   })
    // },
    addBtn(){
      this.isNewReminder = true
    },
    searchBtn () {
     this.getListData()
    },
    clearBtn(){
      this.handleAllclear()
      this.getListData()
    },
    dialogCler(){
      this.handleDialogclear()
    },
    dialogSubit(){
      let data = {
        id:"",
        msgType: 1,
        teacherId: this.ewReminder.teacher,
        studentId: this.ewReminder.student,
        subject: this.ewReminder.subject,
      }
      ApiExhortNews(data).then((res)=>{
        if(res.code == 200){
          // this.$message({type: 'success',message: '查询成功'});
          this.isNewReminder = false
          this.getListData()
          this.handleDialogclear()
        }else{
          this.$message({type: 'error',message: '添加失败'});
        }
      })
    },
    handlescreenshotCler(){
      this.screenshot = ""
      this.fileLists = [];
      this.showMsg = null
      this.screenshotShow = false
    },
    handlescreenshotSubmit(){
      let data = {
        msgId: this.showMsg.msgId,
        marketStatus: this.showMsg.marketStatus,
        remark: this.screenshot,
      }
      ApiStatus(data).then((res)=>{
        if(res.code == 200){
          this.handlescreenshotCler()
          this.getListData()
        }
      })
    },
    handleDialogclear(){
      this.isNewReminder = false
      this.ewReminder = {
        teacher:"",
        student:"",
        subject:"",
      }
    },
    handleAllclear(){
      this.formDate =  {
        student:"",
        assistantId:'',
        teacher:"",
        subject:"",
        teacherCompleted:"",
        salesCompleted:"",
        salesReview:"",
        recentlyTime:[],
        createTime:[],
        salesTime:[],
        regionName:'',
      }
      this.pagination.pageNo = 1
      this.pagination.pageSize = 10
    },
    getListData(){
      this.isLoading = true
    
      let str = ""
      if(this.formDate.student){
        str = this.formDate.student + ''
        if(this.formDate.student1){
          str =  this.formDate.student + ',' + this.formDate.student1
        }
      }else{
        if(this.formDate.student1){
          str = this.formDate.student1  + ''
        }
      }

     
      
      let data = {
          phone: "",
          msgType: 1,
          pageIndex: this.pagination.pageNo,
          pageSize: this.pagination.pageSize,

          studentIds: str,

          // studentId: this.formDate.student,

          teacherId: this.formDate.teacher,
          subject: this.formDate.subject,
          msgStatus: this.formDate.teacherCompleted,
          marketStatus: this.formDate.salesCompleted,
          marketCheckStatus: this.formDate.salesReview,
          startTime: this.formDate.recentlyTime ? this.formDate.recentlyTime[0] : "",
          endTime: this.formDate.recentlyTime ? this.formDate.recentlyTime[1] : "",
          salesStartTime: this.formDate.salesTime ? this.formDate.salesTime[0] : "",
          salesEndTime: this.formDate.salesTime  ? this.formDate.salesTime[1] : "",
          createStartTime: this.formDate.createTime ? this.formDate.createTime[0] : "",
          createEndTime: this.formDate.createTime ? this.formDate.createTime[1] : "",

          assistantId: this.formDate.assistantId ? this.formDate.assistantId : "",

          regionName: this.formDate.regionName || localStorage.getItem('cityTepy'),
      }

      getList(data).then((res)=>{
       if(res.code == 200){
          this.tableData = res.data
          this.isLoading = false
          this.pagination.pageNo = res.pageIndex
          this.pagination.total = res.totalSize
          // this.handleApiGetMessageState()

          let dataTop = {
            xueguanshenhezhong: res.unfinishedWharn,
            teacherOk: res.messageTotal,
            teacherDaiTiJiao: res.accomplisWharn,
            marketOk: res.marketAccomplish,
            marketNotOk: res.marketUnfinished,
          }
          this.dataTop = dataTop


          this.$message({type: 'success',message: '查询成功'});
       }
      })
    },

    showChatDetailEvent(even){
      this.showChatDetail = even
      this.row = null
    },

    detail(row){
      if(row.student && row.teacher){
        // this.$router.push({ path: "/chatDetail", query: { row } })
        this.row = row
        this.showChatDetail = true
      }else{
        this.$message({type: 'warning',message: '获取老师或学生错误信息'});
      }
    },

    handleSizeChange (v) {
      this.pagination.pageSize = v;
      this.getListData();
    },

    handleCurrentChange (v) {
      this.pagination.pageNo = v;
      this.getListData();
    },

    handleGetlistData(){
      this.$message({type: 'success',message: '已取消'});
    },

    changeMarke (row) {

      // if(row.msg.marketStatus == 1){
      //    this.$message({message: '审核状态必须已完成',type: 'warning' });
      // }else{
        this.$confirm('此操作将修改销售完成情况, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
             this.screenshotShow = true
             this.showMsg = row.msg
          }).catch(() => {
            row.msg.marketStatus = 2
            this.$message({type: 'warning',message: '已取消'});
          });
      // }

    },

    handleImgClick(row) {
      this.showImg = row;
      this.isShowImg = true;
    },

    handleNewReminderClose(){
      this.isNewReminder = false
      this.handleDialogclear()
    },

    handleInitialization(){
      // getStudents().then(res => {
      //   this.studentArr = res.data
      // })

      getStudentsType(2).then(res => {
        this.studentArr = res.data
      })
      getStudentsType(1).then(_res => {
        this.studentArr1 = _res.data
      })
      axios.get(`${apiBaseUrl}/schedule/assistantList`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(response => { this.teacherArrr = response.data.data;  })
      getTeachers().then(res => {
        this.teacherArr = res.data
      })
      getSubject().then(res => {
        this.subjectArr = res.data
      })
    },


    getFileName(name) {
      return name.substring(name.lastIndexOf("."));
    },
    beforeUpload(file) {
      // 限制上传类型
      const fileExtensions =
        this.getFileName(file.name) === ".bmp" ||
        this.getFileName(file.name) === ".tif" ||
        this.getFileName(file.name) === ".gif" ||
        this.getFileName(file.name) === ".pcx" ||
        this.getFileName(file.name) === ".svg" ||
        this.getFileName(file.name) === ".psd" ||
        this.getFileName(file.name) === ".webp" ||
        this.getFileName(file.name) === ".apng" ||
        this.getFileName(file.name) === ".ai" ||
        this.getFileName(file.name) === ".avif" ||
        this.getFileName(file.name) === ".png" ||
        this.getFileName(file.name) === ".pdf"||
        this.getFileName(file.name) === ".jpg";
      //限制的上限为20M
      const max20M = file.size / 1024 / 1024 < 20;
      if (!fileExtensions) {
        this.$message.error("上传文件类型只能是 .png, .jpg, .pdf 格式!");
      }
      if (!max20M) {
        this.$message.error("上传文件大小不能超过 20MB!");
      }
      return fileExtensions && max20M;
    },
    handleUpload(option) {
      var obj = option.file.name;
      var index = obj.lastIndexOf(".");
      obj = obj.substring(index, obj.length);
      // 生成的文件名，保留文件后缀名，进行拼接
      let objName = getFileNameUUID() + this.getFileName(option.file.name);
      // 调用 ali-oss 中的方法,flieName是存放的文件夹名称，可自己定义
      put(`mz_pc/${objName}`, option.file).then((res) => {
        
        this.screenshot = res.url
        // 上传成功之后，转换真实的地址
        signatureUrl(`mz_pc/${objName}`).then((res) => {
          
        });
      });
    },
    handleRemove(file, fileList) {
      this.fileLists = fileList;
      this.screenshot = ""
    },


  }

}

</script>


<style scoped>
header {
  text-align: left;
}

.pending {
  text-align: left;
}

.pending p {
  font-size: 14px;
}

.pending_bottom {
  width: 100%;
  height: 140px;
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-radius: 10px;
}

.pending_item {
  width: 170px;
  height: 100px;
  border-radius: 10px;
}

.pending_item p {
  margin-top: 20px;
  margin-left: 25px;
}

.leave {
  background: linear-gradient(to right, #028bcf, #80d0f6);
}

.renew {
  background: linear-gradient(to right, #fdbe29, #fecf64);
}

.communication {
  background: linear-gradient(to right, #5d9656, #aac8a6);
}

.afterClass {
  background: linear-gradient(to right, #ff698a, #fe9f74);
}

.first {
  background: linear-gradient(to right, #d87ea3, #e3c5c6);
}

.classroom {
  background: linear-gradient(to right, #1da8aa, #94e0dd);
}

.issue {
  background: linear-gradient(to right, #f4ab56, #f6cd9e);
}

.demo-form-inline {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.avatar-uploader >>> .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  margin-right: 88%;
  margin: 0 ;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.el-upload {
  border: 1px dashed #d9d9d9 !important;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.demo-form-inline .el-form-item {
  margin-right: 30px;
}

/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .fiveLessons {
    width: 1430px;
  }

  /* 兼容移动端 */
  #aa>>>.fiveLessons {
    width: 70% !important;
  }
}
.el-upload .el-upload--text{
  margin: 0 auto !important;
}
.btns{
  background-color: #428BCA;
  border-color: #428BCA;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/manager/afterSales/weekendReminder.vue